import clsx from "clsx";

import { Badge } from "@components/v2";
import { type SalesMetricRow } from "@north-beam/nb-common";
import { type CellContext } from "@tanstack/react-table";

export const CellStatus = ({
  cell,
}: {
  cell: CellContext<SalesMetricRow, string>;
}) => {
  return (
    <div
      className={clsx(
        "border-r-1 border-x-v2-tertiary px-4 py-2.5 h-full bg-inherit text-v2-primary",
        "flex items-center gap-3 justify-between text-sm w-full",
      )}
    >
      {cell.getValue() === "active" && <Badge variant="notice">Active</Badge>}
      {cell.getValue() === "inactive" && (
        <Badge variant="pending">Inactive</Badge>
      )}
    </div>
  );
};
